var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8984 21.9258C16.9219 21.9258 16.1211 21.5742 15.3594 20.7734L0.886719 6.00781C0.300781 5.42188 0.0078125 4.69922 0.0078125 3.83984C0.0078125 2.12109 1.41406 0.714844 3.11328 0.714844C3.97266 0.714844 4.77344 1.06641 5.39844 1.71094L17.8789 14.582L30.3789 1.71094C31.0234 1.06641 31.8047 0.714844 32.6836 0.714844C34.4023 0.714844 35.7891 2.12109 35.7891 3.83984C35.7891 4.69922 35.4961 5.42188 34.9102 6.00781L20.4375 20.7734C19.6562 21.5938 18.8555 21.9258 17.8984 21.9258Z",
    fill: "#FAEEE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scrollDown.bc7b57b37a73ab4ce9315822605dc8db.svg";
export { ForwardRef as ReactComponent };